import SearchResult from './SearchResult.vue';

export default SearchResult;
